/* Galeria de produto — comportamento e filtro por variante de cor.
   As imagens sem data-ca-color são as cinco bases e permanecem sempre visíveis. */
class CaGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ca-track]');
    if (!this.track) return;
    this.allSlides = Array.from(this.querySelectorAll('[data-ca-slide]'));
    this.allDots = Array.from(this.querySelectorAll('[data-ca-dot]'));
    this.allThumbs = Array.from(this.querySelectorAll('[data-ca-thumb]'));
    this.slides = this.allSlides;
    this.dots = this.allDots;
    this.thumbs = this.allThumbs;
    this.counter = this.querySelector('[data-ca-counter]');
    this.index = 0;

    this.allDots.forEach((d) => d.addEventListener('click', () => this.go(this.dots.indexOf(d))));
    this.allThumbs.forEach((t) => {
      t.addEventListener('click', () => this.go(this.thumbs.indexOf(t)));
      t.addEventListener('mouseenter', () => {
        if (matchMedia('(min-width: 750px)').matches) this.go(this.thumbs.indexOf(t));
      });
    });

    var prev = this.querySelector('[data-ca-prev]');
    var next = this.querySelector('[data-ca-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
    if (next) next.addEventListener('click', () => this.go(this.index + 1));

    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          var i = this.slides.indexOf(e.target);
          if (i >= 0 && e.isIntersecting && e.intersectionRatio > 0.6) this.setActive(i);
        });
      }, { root: this.track, threshold: [0.6] });
      this.allSlides.forEach((s) => this.io.observe(s));
    }

    this.track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
    });

    this.onVariantChange = (e) => {
      if (!e.target.closest('variant-picker')) return;
      this.applyColor(this.selectedColor());
    };
    document.addEventListener('change', this.onVariantChange);
    this.applyColor(this.selectedColor());
    this.setupLightbox();
  }

  disconnectedCallback() {
    if (this.io) this.io.disconnect();
    if (this.onVariantChange) document.removeEventListener('change', this.onVariantChange);
  }

  normalize(value) {
    return (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  selectedColor() {
    var picker = document.querySelector('variant-picker[data-template-product-match="true"]');
    if (!picker) return '';
    var selected = Array.from(picker.querySelectorAll(
      'input:checked[data-option-name], select option:checked[data-option-name]'))
      .find((option) => /^color$/i.test(option.dataset.optionName || ''));
    return selected ? selected.value : '';
  }

  applyColor(color) {
    var wanted = this.normalize(color);
    var baseCount = this.allSlides.filter((s) => !s.dataset.caColor).length;
    var colorCount = wanted ? this.allSlides.filter((s) => this.normalize(s.dataset.caColor) === wanted).length : 0;
    var complete = wanted && baseCount > 0 && colorCount === baseCount;
    var match = (node) => {
      if (!wanted) return true;
      if (complete) return this.normalize(node.dataset.caColor) === wanted;
      return !node.dataset.caColor || this.normalize(node.dataset.caColor) === wanted;
    };
    this.allSlides.forEach((s) => { s.hidden = !match(s); s.setAttribute('aria-hidden', String(!match(s))); });
    this.allDots.forEach((d) => { d.hidden = !match(d); d.setAttribute('aria-hidden', String(!match(d))); });
    this.allThumbs.forEach((t) => { t.hidden = !match(t); t.setAttribute('aria-hidden', String(!match(t))); });
    this.slides = this.allSlides.filter(match);
    this.dots = this.allDots.filter(match);
    this.thumbs = this.allThumbs.filter(match);
    var initial = wanted ? this.slides.findIndex((s) => this.normalize(s.dataset.caColor) === wanted) : 0;
    if (initial < 0) initial = 0;
    this.index = -1;
    this.go(initial);
  }

  go(i) {
    if (!this.slides.length) return;
    if (i < 0) i = this.slides.length - 1;
    if (i >= this.slides.length) i = 0;
    var s = this.slides[i];
    if (!s) return;
    this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    this.setActive(i);
  }

  setActive(i, force) {
    if (i < 0 || i >= this.slides.length || (!force && i === this.index)) return;
    this.index = i;
    var activeSlide = this.slides[i];
    var activeDot = this.dots[i];
    var activeThumb = this.thumbs[i];
    this.allSlides.forEach((s) => s.classList.toggle('is-active', s === activeSlide));
    this.allDots.forEach((d) => { d.classList.toggle('is-active', d === activeDot); d.setAttribute('aria-selected', String(d === activeDot)); });
    this.allThumbs.forEach((t) => { t.classList.toggle('is-active', t === activeThumb); t.setAttribute('aria-selected', String(t === activeThumb)); });
    if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.slides.length;
  }

  setupLightbox() {
    var dlg = this.parentElement && this.parentElement.querySelector('[data-ca-lightbox]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var stage = dlg.querySelector('[data-ca-lb-stage]');
    var close = dlg.querySelector('[data-ca-lb-close]');
    var self = this;
    function open() {
      var img = self.slides[self.index] && self.slides[self.index].querySelector('img');
      if (!img) return;
      stage.innerHTML = '';
      var big = new Image();
      big.src = img.currentSrc || img.src;
      big.alt = img.alt;
      big.className = 'ca-lightbox__img';
      big.addEventListener('click', function () { big.classList.toggle('is-zoomed'); });
      stage.appendChild(big);
      dlg.showModal();
    }
    var zoomBtn = this.querySelector('[data-ca-zoom]');
    if (zoomBtn) zoomBtn.addEventListener('click', open);
    this.allSlides.forEach((s) => s.addEventListener('click', open));
    if (close) close.addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
  }
}
if (!customElements.get('ca-gallery')) customElements.define('ca-gallery', CaGallery);
